import React, { useEffect, useState } from 'react';
import { Box, Button } from '@spothero/ui';
import { useDispatch, useSelector } from 'react-redux';
import { toggleShowTotal } from 'store/filters/filters-actions';
import totalPriceChanged from 'segment/events/search/total-price-changed';
import { useShowTotal } from 'store/selectors/hooks/useShowTotal';
import { persistTotalPriceSessionPreference } from 'utils/total-price-session-utils';
// Copied from src/js/pages/search-transient-event-monthly/components/search-transient-inout-filter/SearchTransientInOutFilter.jsx
const stylingProps = (filterApplied = false) => ({
    '& .QuickFilters-filter': {
        margin: 0,
        backgroundColor: filterApplied ? 'primary.600' : undefined,
        color: filterApplied ? 'white' : undefined,
        '.SpotListSearchControlsCondensed &': {
            backgroundColor: filterApplied ? 'primary.600' : 'white',
            color: filterApplied ? 'white' : 'black',
        },
    },
    button: {
        width: '100%',
        flexGrow: 1,
        flexShrink: 1,
        justifyContent: 'center',
    },
});
export default function TotalToggle() {
    const dispatch = useDispatch();
    const state = useSelector((s) => s);
    const showTotal = useShowTotal();
    const [isClient, setIsClient] = useState(false);
    const handleClick = () => {
        const newShowTotal = !showTotal;
        dispatch(toggleShowTotal(newShowTotal));
        persistTotalPriceSessionPreference(newShowTotal);
        totalPriceChanged(state);
    };
    const styling = stylingProps(showTotal);
    useEffect(() => {
        setIsClient(true);
    }, []);
    return (isClient && (<Box flexGrow={1} gap="3" maxWidth="10rem" sx={styling}>
                <Button _hover={{
            backgroundColor: 'transparent',
            borderColor: 'accent',
            color: 'text.primary.light',
        }} fontSize="sm" display="flex" alignItems="center" marginLeft={4} borderColor="accent" fontWeight="normal" backgroundColor="inherit" color="inherit" className={`QuickFilters-filter ${showTotal
            ? 'QuickFilters-TotalToggle--active'
            : 'QuickFilters-TotalToggle--inactive'}`} data-testid={`QuickFilters-showTotal-${showTotal}`} onClick={handleClick}>
                    Total Price
                </Button>
            </Box>));
}
